import React from "react";
import { useTranslation } from "react-i18next";
import { YearSelector } from "../dates/YearSelector";
import dayjs from "dayjs";

const BeanDateSelector = ({ value, onChange, placeholder }) => {
  const { t } = useTranslation();

  return (
    <YearSelector
      views={["year", "month", "day"]}
      openTo="year"
      minDate={dayjs("2000-01-01")}
      maxDate={dayjs("2030-12-31")}
      defaultValue={null}
      name="StockDate"
      value={value ? dayjs(value) : null}
      onChange={onChange}
      placeholder={t('beens.stockdate')}
    />
  );
};

export default BeanDateSelector;
